module.exports = __webpack_public_path__ + "img/8.5e31e6d5.jpg";